import { cloneDeep, set } from "lodash";
import { NotificationManager } from "react-notifications";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import i18n from "../../../../Utils/i18next/i18next";
import store from "../../../../store";

const { t } = i18n;

export const onSubmit = async (values, props) => {
  const { complaintReducer } = store.getState();
  const { updateTableRegistry, loadData, update, updateSingleRegistry, uuid } =
    props;
  const data = cloneDeep(values);

  // Mapowanie obiektów na relacje oczekiwane przez BE
  if (values?.contractor?.uuid || values?.contractor?.value) {
    set(
      data,
      "contractor.uuid",
      values?.contractor?.uuid || values?.contractor?.value,
    );
  }

  if (values?.device?.uuid || values?.device?.value) {
    set(data, "device.uuid", values?.device?.uuid || values?.device?.value);
  }

  if (values?.representative?.uuid || values?.representative?.value) {
    set(
      data,
      "representative.uuid",
      values?.representative?.uuid || values?.representative?.value,
    );
  }

  if (
    values?.customerExpectations?.uuid ||
    values?.customerExpectations?.value
  ) {
    set(
      data,
      "customerExpectations.uuid",
      values?.customerExpectations?.uuid || values?.customerExpectations?.value,
    );
  }

  if (values?.guarantor?.uuid || values?.guarantor?.value) {
    set(
      data,
      "guarantor.uuid",
      values?.guarantor?.uuid || values?.guarantor?.value,
    );
  }

  // Usuwanie tymczasowych pól tylko do odczytu z PAYLOADU
  delete data.deviceDetails;
  delete data.representativePhone;
  delete data.representativeEmail;

  let payload;

  if (!update) {
    data.status = complaintReducer?.availableStatuses?.find(
      (el) => !!el.isSelected,
    );

    const res = await GlobalAuthFetch({
      path: `/complaint`,
      method: "POST",
      data,
    });
    payload = res.payload;
  }

  if (update) {
    const res = await GlobalAuthFetch({
      path: `/complaint/${uuid}`,
      method: "PATCH",
      data,
    });
    payload = res.payload;
  }

  if (payload?.status >= 300 || !payload?.status) {
    props.setErrorHeader(0, true);
    return;
  }

  props.setErrorHeader(0, false);

  // Success notify
  loadData();
  NotificationManager.success(i18n.t("global:success"));
  if (updateSingleRegistry) updateSingleRegistry();
  if (updateTableRegistry) updateTableRegistry();
  props.handleHide();
};

export const onValidate = (values, props) => {
  const errorsStep0 = {};
  const errorsStep1 = {};

  // ---------------- STEP 0 (KROK 1) WALIDACJA ----------------

  // Kontrahent (wymagany)
  if (!values.contractor) {
    errorsStep0.contractor = t("global:complaints.errors.contractorRequired");
  }

  // Data przyjęcia reklamacji (wymagana)
  if (!values.receivedDate) {
    errorsStep0.receivedDate = t(
      "global:complaints.errors.receivedDateRequired",
    );
  }

  // Urządzenie (wymagane)
  if (!values.device) {
    errorsStep0.device = t("global:complaints.errors.deviceRequired");
  }

  // Osoba do kontaktu (wymagana)
  if (!values.representative) {
    errorsStep0.representative = t(
      "global:complaints.errors.representativeRequired",
    );
  }

  // Walidacja: plannedClosingDate nie może być wcześniejsza niż receivedDate
  if (values.receivedDate && values.plannedClosingDate) {
    const received = new Date(values.receivedDate).getTime();
    const planned = new Date(values.plannedClosingDate).getTime();

    if (planned < received) {
      errorsStep0.plannedClosingDate = t(
        "global:complaints.errors.plannedDateBeforeReceived",
      );
    }
  }

  // ---------------- Czerwony nagłówek walidacji błędów dla kroków ----------------
  if (
    !props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length > 0
  ) {
    props.setErrorHeader(0, true);
  }
  if (
    !!props.steps[0]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep0).length <= 0
  ) {
    props.setErrorHeader(0, false);
  }

  if (
    !props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length > 0
  ) {
    props.setErrorHeader(1, true);
  }
  if (
    !!props.steps[1]?.error &&
    props.isSubmit &&
    Object.keys(errorsStep1).length <= 0
  ) {
    props.setErrorHeader(1, false);
  }

  return { ...errorsStep0, ...errorsStep1 };
};
